<template>
    <div class="container-fluid p-0">
        <TopBar/>
        <div class="banner">
            <div id="particles-js"></div>
            <div class="container">
                <div class="row pt-5">
                    <div class="col text-left">
                        <img class="logo-left" src="../assets/images/logo-air.png">
                    </div>
                    <div class="col text-right">
                        <img class="logo-left" src="../assets/images/logos.png">
                    </div>
                </div>
                <div class="row pt-5">
                    <div class="col-12 col-md-8 m-auto">
                        <div class="slogan">
                            <h1>Контроль повітря</h1>
                            <h2>Це безпека існування</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="banner__footer">
                <h1>Наше рішення</h1>
                <p>ідеально підходить для наступних сфер застосування</p>
            </div>
        </div>
        <div class="content">
            <div id="particles-js2"></div>
            <div class="container">
                <div class="row py-5">
                    <div class="col-12 col-md-4 text-center pb-4 pb-md-0">
                        <i class="icon-parliament"></i>
                        <h3 class="py-2 font-weight-bold">Державні структури</h3>
                        <i>(екологія, безпека, самоврядування та інше)</i>
                    </div>
                    <div class="col-12 col-md-4 text-center pb-4 pb-md-0">
                        <i class="icon-company"></i>
                        <h3 class="py-2 font-weight-bold">Промисловість</h3>
                        <i>(велика та мала промисловість)</i>
                    </div>
                    <div class="col-12 col-md-4 text-center pb-4 pb-md-0">
                        <i class="icon-school"></i>
                        <h3 class="py-2 font-weight-bold">Навчальні заклади</h3>
                        <i>(школи, дитячі садочки, університети та інше)</i>
                    </div>
                </div>
                <div class="divider p-0 m-0"></div>
                <div class="content__long-text my-5 text-center">
                    <strong>Станція моніторингу повітря</strong> - це пристрій, який дозволяє моніторити концентрацію CO2,
                    здійснювати контроль та реєстрацію стану повітря навколишнього середовища, а саме показники температури,
                    вологості та концентрації пилу РМ2.5 і РМ10 в режимі реального часу.
                    Модуль є економічно ефективним інструментом, що задовольняє потреби всіх зацікавлених в підтримці
                    належного рівня навколишнього середовища.
                    Показник РМ2.5 відображає концентрацію твердих частинок діаметром до 2.5 мікрометра. Показник РМ10
                    відображає концентрацію твердих частинок діаметром до 10 мікрометрів.
                </div>
                <div class="content__banner my-5 p-4 text-left">
                    Передача даних відбувається по мережі LoRaWAN.
                    Покриття мережі LoRaWAN є стійким, та може швидко розгорнутись в потрібній локації.
                    Пристрої не потребують додаткового обладнання, SIM-карт, тощо.
                </div>
            </div>
            <div class="container mx-auto mb-4 mb-lg-0">
                <Map @ready="mapReady"/>
            </div>
            <div class="container">
                <div class="row mt-5 d-none d-md-block">
                    <div class="col-12 text-center">
                        <img class="content__control-image" src="../assets/images/control.png">
                    </div>
                </div>
                <div class="row pt-2 content__control-list">
                    <div class="col-12 col-md-4 text-left pb-5 pl-5">
                        <h4 class="font-weight-bold">Державні структури</h4>
                        <small>(екологія, безпека, самоврядування та інше)</small>
                        <ul class="pt-3 pl-3 text-left pb-0 mb-0">
                            <li>Виявлення джерела</li>
                            <li>Запобігання перегріву</li>
                            <li>Запобігання переохолодження</li>
                            <li>Нормалізація температури</li>
                        </ul>
                    </div>
                    <div class="col-12 col-md-4 text-left pb-5 pl-5">
                        <h4 class="font-weight-bold">Промисловість</h4>
                        <small>(велика та мала промисловість)</small>
                        <ul class="pt-3 pl-3 text-left pb-0 mb-0">
                            <li>Виявлення джерела</li>
                            <li>Своєчасна ліквідація</li>
                            <li>Запобігання хвороб</li>
                            <li>Екологічна чистота</li>
                        </ul>
                    </div>
                    <div class="col-12 col-md-4 text-left pb-5 pl-5">
                        <h4 class="font-weight-bold">Учбові заклади</h4>
                        <small>(школи, дитячі садочки, університети та інше)</small>
                        <ul class="pt-3 pl-3 text-left pb-0 mb-0">
                            <li>Виявлення джерела</li>
                            <li>Своєчасна ліквідація</li>
                            <li>Запобігання катастроф</li>
                            <li>Міцне здоров'я</li>
                        </ul>
                    </div>
                </div>
                <div class="divider p-0 m-0"></div>
                <div class="row my-5">
                    <div class="col-12 text-center mb-5 mt-0">
                        <h1>Працюючи з нами ви отримаєте:</h1>
                    </div>
                    <div class="col-12 col-md-3 text-center mb-5">
                        <i class="icon-project icon-5x"></i>
                        <h4 class="my-3 font-weight-bold">Проектування</h4>
                        <small>Починаючі від ідеї та закінчуючи працюючою системою</small>
                    </div>
                    <div class="col-12 col-md-3 text-center mb-5">
                        <i class="icon-hours icon-5x"></i>
                        <h4 class="my-3 font-weight-bold">Підтримка 24/7</h4>
                        <small>Підтримка програмного забезпечення та обладнання</small>
                    </div>
                    <div class="col-12 col-md-3 text-center mb-5">
                        <i class="icon-certificate icon-5x"></i>
                        <h4 class="my-3 font-weight-bold">Гарантію</h4>
                        <small>Надаємо гарантію на все обладнання</small>
                    </div>
                    <div class="col-12 col-md-3 text-center mb-5">
                        <i class="icon-tools icon-5x"></i>
                        <h4 class="my-3 font-weight-bold">Обслуговування</h4>
                        <small>Сервісний та гарантійний ремонт. Заміна запчастин та ін.</small>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        <Modal/>
        <FwMapPopup/>
    </div>
</template>

<script>

    import Map from "../components/Map"
    import TopBar from "../components/TopBar";
    import Footer from "../components/Footer";
    import Modal from "../components/Modal";
    import FwMapPopup from "../components/FwMapPopup";
    import "particles.js"

    import Particle from "../assets/json/particles.json";
    import ParticleFooter from "../assets/json/particles.json";
    import EventBus from "../components/EventBus";

    export default {
        name: 'Home',
        components: {
            TopBar,
            Footer,
            Modal,
            Map,
            FwMapPopup
        },
        methods: {
            mapReady() {
                setTimeout(() => {
                    EventBus.$emit("PRELOADER_HIDE");
                }, 300);
            }
        },
        mounted() {
            document.title = "Розумне місто - Головна";
            window.particlesJS('particles-js', Particle);
            window.particlesJS('particles-js2', ParticleFooter);
        }
    }
</script>
